export const LOADING = 'LOADING';
export const LOADING_PERIOD = 'LOADING_PERIOD';
export const LOADING_FILE = 'LOADING_FILE';
export const ERROR = 'ERROR';

export const LOADING_COMPLEMENT = 'LOADING_COMPLEMENT';
export const LOAD_PERIODS = 'LOAD_PERIODS';

export const LOGIN_PORTAL = 'LOGIN';
export const LOGOUT = 'LOGOUT';

export const GET_ACCOUNT_USER = 'GET_ACCOUNT_USER';
export const PATCH_ACCOUNT_USER = 'PATCH_ACCOUNT_USER';
export const GET_ACCOUNT_IMG_USER = 'GET_ACCOUNT_IMG_USER';
export const POST_ACCOUNT_IMG_USER = 'POST_ACCOUNT_IMG_USER';

export const GET_ACCOUNT_VACATION = 'GET_ACCOUNT_VACATION';

export const GET_BENEFITS = 'GET_BENEFITS';
export const SAVE_BENEFIT = 'SAVE_BENEFIT';
export const CACHE_BENEFIT = 'CACHE_BENEFIT';
export const CLEAN_BENEFIT = 'CLEAN_BENEFIT';
export const UPDATE_BENEFIT = 'UPDATE_BENEFIT';
export const DELETE_BENEFIT = 'DELETE_BENEFIT';

//Admin Section 
export const GET_USERS = 'GET_USERS';
export const SAVE_USER = 'SAVE_USER';
export const SAVE_NEW_USER = 'SAVE_NEW_USER';
export const DISLABED_USER = 'DISLABED_USER';

export const SAVE_LIQUIDATION = 'SAVE_LIQUIDATION';
export const DELETE_LIQUIDATION = 'DELETE_LIQUIDATION';